module.exports = __webpack_public_path__ + "static/media/social-twitch.631a8ce2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-twitch.svg
// module id = 421
// module chunks = 0